<app-vehicle-grid
  (mySelected)="grid_onSelected($event)"
  (markers)="grid_markers($event)"
  [templateFormTop]="templateFormTop"
  [templateFormBottom]="templateFormBottom"
  [extraFields]="extraFields"></app-vehicle-grid>

